import o from "clsx";
import e from "react";
import { s as r } from "../../../../../RideIcon.module-BjMwOP4j.mjs";
function c({
  size: t = "small",
  accessibilityTitle: n = "ricon gasoline light",
  className: l,
  "data-testid": a
}) {
  const i = () => o(l, r["ride-icon"], {
    [r[`size-${t}`]]: t
  });
  return /* @__PURE__ */ e.createElement("div", { className: i(), "data-testid": a }, /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "64",
      height: "64",
      viewBox: "0 0 64 64",
      fill: "none",
      stroke: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    n && /* @__PURE__ */ e.createElement("title", null, n),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M49 2H21C17.14 2 14 5.14 14 9V17.125H9.25C7.04 17.125 5.25 18.915 5.25 21.125V31.25C5.25 31.8825 5.5425 32.4425 6 32.81V42C6 45.3075 8.6925 48 12 48H14V50.3075C11.6775 51.0925 10 53.29 10 55.875V56.125C10 59.365 12.635 62 15.875 62H38.355C37.515 61.4175 36.7175 60.76 35.9775 60.02C35.34 59.3825 34.765 58.705 34.25 58H15.875C14.84 58 14 57.16 14 56.125V55.875C14 54.84 14.84 54 15.875 54H32.1C31.6125 52.7025 31.29 51.36 31.13 50H18V9C18 7.345 19.345 6 21 6H49C50.655 6 52 7.345 52 9V31.475C53.395 31.81 54.7375 32.3175 56 32.9925V9C56 5.14 52.86 2 49 2ZM14 44H12C10.8975 44 10 43.1025 10 42V33.1025C10.7325 32.805 11.25 32.0875 11.25 31.2475V23.8725C11.25 23.32 11.6975 22.8725 12.25 22.8725H14V43.9975V44ZM44 10H26C23.795 10 22 11.795 22 14V27C22 29.205 23.795 31 26 31H44C46.205 31 48 29.205 48 27V14C48 11.795 46.205 10 44 10ZM44 27H26V14H44V27Z",
        fill: "url(#paint0_linear_2522_1315)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M57.9 38.1001C52.4325 32.6326 43.5675 32.6326 38.1 38.1001C32.6325 43.5676 32.6325 52.4326 38.1 57.9001C43.5675 63.3676 52.4325 63.3676 57.9 57.9001C63.3675 52.4326 63.3675 43.5676 57.9 38.1001ZM51.515 53.2926C49.575 55.2326 46.4275 55.2326 44.485 53.2926C42.6825 51.4901 42.555 48.6476 44.1 46.6976C44.6225 46.0401 45.08 45.3326 45.5325 44.6251L48.0025 40.7501L50.4725 44.6251C50.925 45.3326 51.3825 46.0401 51.905 46.6976C53.45 48.6476 53.3225 51.4901 51.52 53.2926H51.515Z",
        fill: "url(#paint1_linear_2522_1315)"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint0_linear_2522_1315",
        x1: "5.25",
        y1: "2",
        x2: "40.9362",
        y2: "69.9153",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { offset: "0.272135", stopColor: "#34263B" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "0.658079", stopColor: "#13172C" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint1_linear_2522_1315",
        x1: "33.9994",
        y1: "62.0008",
        x2: "62.0006",
        y2: "33.9995",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#F81E42" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#FA6981" })
    ))
  ));
}
export {
  c as RideIcGasolineLight
};
